module.exports = __webpack_public_path__ + "static/media/jerajera-2020-logo.cb18b291.svg";